ReportsController.$inject = ['$scope', 'Club', 'ReportsChartService', 'moment'];

/* @ngInject */
function ReportsController($scope, Club, ReportsChartService, moment) {
    var vm = this;
    vm.title = 'ReportsController';

    vm.from = moment().subtract(2, 'day').startOf('month');
    vm.to = moment().subtract(1, 'day');

    vm.date = {
        current: moment().format('YYYY-MM-DD'),
        opened: false,
        open: function () {
            vm.date.opened = true;
        },
        formats: 'DD [de] MMMM [del] YYYY',
        format: 'YYYY-MM-DD',
        options: {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: moment(),
            //minDate: new Date(),
            startingDay: 1,
            showWeeks: false,
            datepickerMode: 'day'
        }
    };

    vm.month = {
        current: moment().format('YYYY-MM-DD'),
        opened: false,
        open: function () {
            vm.month.opened = true;
        },
        format: 'YYYY-MM-DD',
        options: {
            todayBtn: false,
            formatYear: 'yy',
            maxDate: moment(),
            //minDate: new Date(),
            minMode: 'month',
            startingDay: 1,
            showWeeks: true,
            datepickerMode: 'month'
        }
    };

    $scope.$watch('vm.month.current', function (month, old) {
        if (month === old) return;

        month = moment(month);
        var end_month = moment(month).endOf('month'),
            present = moment().subtract(1, 'day');

        vm.from = moment(month).startOf('month');
        vm.to = end_month.isAfter(present) ? present : end_month;
        fetch();

    }, true);

    var chartData = null;

    vm.chart_monthly = {};
    vm.chart_monthly_options = {
        // Sets the chart to be responsive
        responsive: true,
        tooltips: {
            mode: 'index'
        },
        hover: {
            mode: 'index',
            intersect: true
        },
        scales: {
            yAxes: [{
                ticks: {
                    min: 0,
                    // Make an integer step size
                    callback: function (value) {
                        if (value % 1 === 0) {
                            return value;
                        }
                    }
                }
            }]
        }
    };

    vm.chart_total = {};
    vm.chart_total_options = {
        // Sets the chart to be responsive
        responsive: true
    };

    vm.stats = {};

    vm.chart_view_type = 'success';

    var chart_views = {
        success: ['online', 'offline', 'fixed'],
        cancelled: ['online_cancelled', 'online_reported', 'offline_cancelled', 'fixed_cancelled']
    };

    var chart_view = function () {
        return chart_views[vm.chart_view_type];
    }
    var chart_view_total = function (type) {
        return (vm.chart_view_type === 'success') ? true : false;
    }

    vm.loading = true;

    activate();

    $scope.$watch('vm.chart_view_type', function (view_type, old) {
        if (view_type === old) return;

        render();
    });

    ////////////////

    function activate() {
        fetch();
    }

    function fetch() {
        vm.loading = true;
        Club.API.customGET('reports/stats', {
            from: vm.from.format('YYYY-MM-DD'),
            to: vm.to.format('YYYY-MM-DD')
        })
            .then(function (result) {
                chartData = ReportsChartService.extractGraphInfo(result.plain(), vm.from, vm.to);
                render();

                vm.loading = false;
            })
            .catch(console.error);
    }

    function render() {
        vm.chart_monthly = ReportsChartService.buildGraph(chartData, chart_view(), chart_view_total());
        vm.chart_total = ReportsChartService.buildCakeGraph(chartData, chart_view());
        vm.stats = ReportsChartService.buildStats(chartData, chart_views);
    }
}


export default ReportsController;